import Swiper from 'swiper/bundle';

export default new class LastWorks {
    constructor() {
        this.init()
    }

    init() {
        const portfolioSwiper = new Swiper('.lastworksSwiper', {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 1,
            loop: true,
            minWidth:300,
            spaceBetween: 70,
            // Navigation arrows
            navigation: {
                nextEl: '.portfolio-slider-next',
                prevEl: '.portfolio-slider-prev',
            },
        });
    }
}
